import React from 'react'
import classes from "./Fourth.module.scss"
import img1 from "../../../assets/img/costcall/4/1.png"
import img2 from "../../../assets/img/costcall/4/2.png"
import img3 from "../../../assets/img/costcall/4/3.png"
import img4 from "../../../assets/img/costcall/4/4.png"

const Fourth = () => {
    return (
        <div className={[classes.fourth, ""].join(" ")}>
            <div className={[classes.fourthBody, ""].join(" ")}>
                <div className="container">
                    <h2 className={[classes.fourthTitle, "font-40"].join(" ")}>
                        Загружайте Bomber VPN <span>на всех платформах</span>
                    </h2>
                    <div className={[classes.fourthDecor, "decor"].join(" ")}>
                        <span></span><span></span><span></span>
                    </div>
                    <p className={[classes.fourthSubtitle, "font-22"].join(" ")}>
                        Подключайте до десяти устройств и обеспечьте безопасность и конфиденциальность при доступе в Интернет, даже при использовании общественных Wi-Fi сетей.
                    </p>
                    <div className={[classes.fourthRow, ""].join(" ")}>
                        <div className={[classes.fourthRowItem, ""].join(" ")}>
                            <div className={[classes.fourthRowItemImg, ""].join(" ")}>
                                <img src={img1} alt="" />
                            </div>
                            <p className={[classes.fourthRowItemText, "font-22"].join(" ")}>
                                Windows
                            </p>
                        </div>
                        <div className={[classes.fourthRowItem, ""].join(" ")}>
                            <div className={[classes.fourthRowItemImg, ""].join(" ")}>
                                <img src={img2} alt="" />
                            </div>
                            <p className={[classes.fourthRowItemText, "font-22"].join(" ")}>
                                IOS
                            </p>
                        </div>
                        <div className={[classes.fourthRowItem, ""].join(" ")}>
                            <div className={[classes.fourthRowItemImg, ""].join(" ")}>
                                <img src={img3} alt="" />
                            </div>
                            <p className={[classes.fourthRowItemText, "font-22"].join(" ")}>
                                Android
                            </p>
                        </div>
                        <div className={[classes.fourthRowItem, ""].join(" ")}>
                            <div className={[classes.fourthRowItemImg, ""].join(" ")}>
                                <img src={img4} alt="" />
                            </div>
                            <p className={[classes.fourthRowItemText, "font-22"].join(" ")}>
                                Linux
                            </p>
                        </div>

                    </div>

                </div>
            </div>

        </div>

    )
}

export default Fourth